import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SellersService {

    private sellerUrl = env.url;
    private sellerApi = env.api_sell;
    private _baseDeskPath = env.url + env.api_desk;
    private selectClient = new BehaviorSubject<boolean>(false);
    client$ = this.selectClient.asObservable();
    constructor(private http: HttpClient, private cookies: CookieService) {}

    change_flag_select_client(flag){
        this.selectClient.next(flag);
    }

    get_seller_id(){
        const seller = JSON.parse(localStorage.getItem('seller'));
        return seller['pk']
    }

    login(user: any): Observable<any> {
      return this.http.post("https://reqres.in/api/login", user);
    }
    register(user: any): Observable<any> {
      return this.http.post("https://reqres.in/api/register", user);
    }
    setToken(token: string) {
      this.cookies.set("token", token);
    }
    getToken() {
      return this.cookies.get("token");
    }

    getChartDatas(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );
        }
        return this.http.get(this.sellerUrl + this.sellerApi + 'auth/sellers/corporative' , {params:_params});
    }

    getVerificateDatas(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );
        }

      return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/verificate/', {params:_params});
    }

    getProfileDatas(): Observable<any> {
      return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/profile/');
    }

    updateProfileChartsVisibility(visibility: { totalService?: boolean; installation?: boolean; cfe?: boolean; }): Observable<any> {
      return this.http.put(
        this.sellerUrl + this.sellerApi + 'auth/dashboard/profile/',
        { dashboard_charts_visibility: visibility }
      );
    }

    getLogo(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );
        }
        return this.http.get(this._baseDeskPath + 'auth/seller/logo/');
    }

    getComercialData(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );
        }
      return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/comercial/', {params:_params});
    }

    getOperativeData(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );
        }
      return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/operative/', {params:_params});
    }

    getEnviromentData(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );
        }
      return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/enviroment/', {params:_params});
    }

    getMonitoringData(): Observable<any> {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );

        }
      return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/monitoring/', {params:_params});
    }


    // Enpoints to map

    getCoordenatesToPlants(type_map: string): Observable<any>
    {
        let _params = new HttpParams();
        if (localStorage.getItem('seller')) {
            _params = _params.set('seller',this.get_seller_id() );

        }
        return this.http.get(this.sellerUrl + this.sellerApi + 'auth/dashboard/map/coordinates/?map_type='+type_map , {params:_params})

    }
    getClientDetailInstallation(client_id: string): Observable<any>
    {
        return this.http.get(this._baseDeskPath + 'auth/clients/'+client_id+'/installations');
    }
    getClientDetail(client_id: string): Observable<any>
    {
        return this.http.get(this._baseDeskPath + 'auth/client/selected/'+client_id+'/');
    }
    getInvertersMonitoring(installation_id: string | number): Observable<any>
    {
        return this.http.get(this._baseDeskPath + 'auth/list/plants/installation/'+installation_id+'/');
    }
    postMonitoring(pk: string,data: { status: boolean; }): Observable<any>
    {
        return this.http.post(this._baseDeskPath+'auth/installation/'+pk+'/status/',data)
    }

    getClients(page: Number,params,quickfilterSearchVal: string, pagesize:Number ,completeClients,dropClients,installationRelease, sort, filter): Observable<any>
    {

        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/projects/?page=' + page
        let params_ = new HttpParams();

        if (filter != null) {
            params_ = params_.append('filterModel',JSON.stringify(filter)) ;
        }

        params_ = params_.append('quickfiltersearch',quickfilterSearchVal);
        params_ = params_.append('pagesize',JSON.stringify(pagesize));
        params_ = params_.append('completeclients',completeClients);
        params_ = params_.append('dropclients',dropClients);
        params_ = params_.append('installationrelease',installationRelease);
        if (localStorage.getItem('seller')) {
            params_ = params_.append('seller',this.get_seller_id() );

        }


        sort.forEach(element => {
            params_ = params_.append('sort',element.sort);
            params_ = params_.append('colId',element.colId);
        });

        return this.http.get(url,{params:params_});
    }

    getRoom(clientid:number, installerid:number): Observable<any>
    {
        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/room/?clientID='+clientid+'&installerID='+installerid
        return this.http.get(url ,{params: { use_loading: 'false' } });
    }

    getSellersCorporative(): Observable<any>
    {
        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/list/seller_corporative/'
        return this.http.get(url ,{params: { use_loading: 'false' } });
    }

    getExcel(start_date, end_date){
        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/enviroment/export/'
        let _params = new HttpParams();

        if (localStorage.getItem('seller')) {
            _params = _params.append('seller',this.get_seller_id() );
        }

        _params = _params.set('start_date', start_date );
        _params = _params.set('end_date', end_date );

        return this.http.get(url ,{params: _params}, );
    }

    getTargetNetZero(){
        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/target_netzero/'

        return this.http.get(url,{params: { use_loading: 'false' }});
    }

    putTargetNetZero(data){
        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/target_netzero/'

        return this.http.put(url,data);
    }

    putCalculateTargetNetZero(data){
        let url=this.sellerUrl + this.sellerApi + 'auth/dashboard/calculate/target_netzero/'

        return this.http.put(url,data, {params: { use_loading: 'false' }});
    }

    getAssociatedUsers(): Observable<any> {
        return this.http.get(this._baseDeskPath + 'auth/associated_users/');
    }

    postAssociatedUser(data: any): Observable<any> {
        return this.http.post(this._baseDeskPath + 'auth/associated_users/', data);
    }

    putAssociatedUser(data: any, id: any): Observable<any> {
        return this.http.put(this._baseDeskPath + 'auth/associated_users/' + id + '/', data);
    }

    deleteAssociatedUser(id: any): Observable<any> {
        return this.http.delete(this._baseDeskPath + 'auth/associated_users/' + id + '/');
    }
  }
